// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2D0WM","buttons":"SendReceipts_buttons__2Jbg-","email":"SendReceipts_email__2kVBt","bookApptTitle":"SendReceipts_bookApptTitle__2cbXD"};